import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  IconButton,
} from "@mui/material";
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
// import axios from "axios";
import React, { useCallback, useEffect, useState, useRef } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { DetailTrans } from "../prc/TzaDetailDialog";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import CustomPagination from "../../component/common/CustomPagination";


const initailEvknData: any = {
  idx : -1,

  task: "simpleqa",
  data_sources: "",
  category: "",
  subcategory: "",
  bmk_pk: "",
  difficulty: "",
  keyword: "",
  title: "",
  text: "",
  
  qa_type: "",
  answer_type: "",
  science_fact: "",
  common_knowledge: "",
  
  activity: "",
  question_a: "",
  question_b: "",
  question: "",

  answer: "",
  answer_index: "",

  option_1: "",
  option_2: "",
  option_3: "",
  option_4: "",
  option_5: "",

  reason_1: "",
  reason_2: "",
  reason_3: "",
  reason_4: "",
  reason_5: "",

  job_user:"",
  job_date:"",
  des:"",
};

const newInitailData: any = {
  sentence: [],
  question: "",
  answer: "",
  reason_path: [],
  des: ""
};

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const EvltInsertSentencePage = (props: any) => {

  const [pageType, setPageType] = useState("new")

  const [search_doc_id, setSearch_doc_id] = useState("")

  const [evkn_detail_data, setEvkn_detail_data] = useState<any>(initailEvknData);

  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);

  const [evknWorkList, setEvknWorkList] = useState([]);

  const [sentencesList, setSentencesList] = useState<any>([]);

  const [idx, setIdx] = useState('');
  const [job_yn, setJob_yn] = useState('모두');
  const [gub_cd, setGub_cd] = useState('모두');


  const [backdrop, setBackdrop] = useState<boolean>(false)

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const createInsertSentence = async () => {

    const formDataNew = new FormData();

    formDataNew.append("email", email);

    formDataNew.append("worker", worker);

    const newInsertSentencesData = {
      ...newData,
      reason_path: Array.isArray(reason_path) ? reason_path : (() => {
        try { return JSON.parse(reason_path as string); } catch { return []; }
      })(),
      sentence: Array.isArray(sentenceInfo) ? sentenceInfo : (() => {
        try { return JSON.parse(sentenceInfo as string); } catch { return []; }
      })(),
    };

    formDataNew.append("insertSentences", JSON.stringify(newInsertSentencesData));

    // console.log('new data ?? ' , JSON.stringify(newInsertSentencesData))

    // return ;

    setBackdrop(true)

    await api.post("/createInsertSentence",formDataNew)
    .then((res:any) => {alert("데이터 입력 완료"); setPageType("update"); setBackdrop(false); getEvknWorkInsertSentenceList();})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }


  const updateInsertSentenceData = async () => {

    setBackdrop(true)
    
    const formData = new FormData();

    formData.append("email", email);

    formData.append("worker", worker);

    const updatedInsertSentencesData = {
      ...colEvltData,
      reason_path: Array.isArray(reason_path) ? reason_path : (() => {
        try { return JSON.parse(reason_path as string); } catch { return []; }
      })(),
      sentence: Array.isArray(sentenceInfo) ? sentenceInfo : (() => {
        try { return JSON.parse(sentenceInfo as string); } catch { return []; }
      })(),
    };


    alert(colEvltData.document_id + " 데이터 검수 완료");
    setBackdrop(false);
    return;
    // console.log('업데이트 내용',JSON.stringify(updatedInsertSentencesData))
    // return;
    
    // formData.append("insertSentences", JSON.stringify(updatedInsertSentencesData));

    // await api.post("/updateInsertSentencesData",formData)
    // .then((res:any) => {alert(colEvltData.document_id + " 데이터 검수 완료"); setPageType("update"); setBackdrop(false); getEvknWorkInsertSentenceList();})
    // .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  const [newData, setNewData] = useState<any>(newInitailData);

  const [colEvltData, setColEvltData] = useState<any>([]);

  const [detailInfo, setDetailInfo] = useState<any>([]);

  const [reason_path, setReason_path] = useState<any>([]);

  const reason_path_change = (idx: number, val: string) => {
    setReason_path((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const handleAdd = () => setReason_path((prev) => [...prev, ""]);
  const handleRemove = (idx: number) => setReason_path((prev) => prev.filter((_, i) => i !== idx));

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  const getEvknWorkInsertSentenceList = async () => {
    
    setBackdrop(true)
    api.get('/evltWorkInsertSentencesList',{params:{email:email, type:"MODIFI", worker:worker, page:page, order:order, job_yn:job_yn, gub_cd:gub_cd, idx:idx}})
    .then((res:any) => {
      
      // console.log('리턴 데이터', res.data)
      if(res.data.datas.length > 0){
        // setInstructionList(res.data);
        // setData(res.data.datas[0]);
        setEvknWorkList(res.data.datas);

        // console.log('리스트',res.data.datas)

        if((colEvltData && colEvltData.idx == -1) || (pagination && page != pagination.current_page)){
          setColEvltData(res.data.datas[0])
        }

        setPagination(res.data.pagination)
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        // console.log('api 리턴 데이터', res.data)
        setEvknWorkList(res.data.datas);
        setPagination(res.data.pagination)
        setTotal_cnt(0)
      }
      setBackdrop(false)
      // setPagination(res.data.pagination); 
      })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const getInsertSentenceDetail = async (did:string,sid:string) => {
  
    setBackdrop(true)
    api.get('/getInsertSentenceDetail',{params:{email:email, document_id:did, sentence_id:sid}})
    .then((res:any) => {

      const datas = res.data.datas;
      // console.log('디테일 데이터', datas)
      
      if(datas && datas.length > 0){
        // 첫 번째 데이터 자동 선택
        setDetailInfo(datas[0]);
      }
      setBackdrop(false)
      })
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
  }
  
  const [selectSentence, setSelectSentence] = useState<any>(undefined);
  const [sentenceInfo, setSentenceInfo] = useState<any>([]);
  
  const handleAddSentence = () => {
    setSentenceInfo(prev => {
      const newIndex = prev.length;   // 추가될 새 문장의 인덱스
      setSelectSentence(newIndex);    // 바로 새 문장을 선택 상태로
      return [...prev, ""];           // 빈 문자열로 새 문장 추가
    });
  }

  const handleRemoveSentence = (index: number) => {
    setSentenceInfo((prev) => prev.filter((_, i) => i !== index));
    // 선택된 문장이 삭제된 경우 selectSentence 초기화
    if (selectSentence === index) {
      setSelectSentence(undefined);
    }
  };

  const sentence_change = (idx: number, val: string) => {
    setSentenceInfo((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  }
  
  // 작업 목록 클릭
  const getSentencesData = async (data:any) => {
    
    // console.log('데이터?? ' , data)

    setSentenceInfo(JSON.parse(data.sentence))
    setReason_path(JSON.parse(data.reason_path));
    setColEvltData(data)

  }

  useEffect(() => {
    if(selectSentence != undefined){
      setPageType("update")
    }

    if(props.rowDetail != undefined){
      if(props.rowDetail.instruction_data == 'Y'){
        // getPrcDetail(props.rowDetail.idx)
        // getSwInstructionDetail(props.rowDetail.idx)
        setPageType("update")
      }else{
        setPageType("new")
      }
    }
    getEvknWorkInsertSentenceList()
  }, [page, props.rowDetail]);

  // 1) Ref
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  // 2) 개행 안전 인덱스 계산 (CR, LF, CRLF 모두 처리)
  const getLineStartIndex = (text: string, lineNumber: number) => {
    if (lineNumber <= 1) return 0;

    let count = 1;
    let idx = 0;

    while (count < lineNumber) {
      const nextLF = text.indexOf('\n', idx);
      const nextCR = text.indexOf('\r', idx);
      const next =
        nextLF === -1 ? nextCR :
        nextCR === -1 ? nextLF :
        Math.min(nextLF, nextCR);

      if (next === -1) return text.length;

      // 다음 줄 시작으로 이동
      idx = next + 1;

      // CRLF인 경우 (\r 다음 \n) 한 글자 더 넘김
      if (text[next] === '\r' && text[next + 1] === '\n') idx += 1;

      count += 1;
    }
    return idx;
  };

  // 3) line-height 추정
  const getTextareaLineHeightPx = (textarea: HTMLTextAreaElement, fallback = 24) => {
    const lh = window.getComputedStyle(textarea).lineHeight;
    const px = parseFloat(lh);
    return Number.isFinite(px) ? px : fallback;
  };

  // 4) sentence_change 형식으로 작성된 새 함수 (줄 이동 + 강조 점멸)
  const goToLineChange = (lineNumber: number) => {
    setDetailInfo((prev: any) => {
      const ta = textareaRef.current;
      const text = prev?.modified_context ?? "";

      if (!ta || !text) return prev;

      const line = Math.max(1, Math.floor(lineNumber));
      const start = getLineStartIndex(text, line);

      // 해당 줄의 끝(다음 개행 전) 계산
      let end = text.indexOf('\n', start);
      if (end === -1) end = text.indexOf('\r', start);
      if (end === -1) end = text.length;

      // DOM 조작은 rAF 안에서
      requestAnimationFrame(() => {
        ta.focus();

        // 선택(강조) -> 일정 시간 유지로 점멸
        ta.setSelectionRange(start, end);

        // 중앙 정렬 스크롤: 대상 줄의 top을 중앙에 배치
        const lineHeight = getTextareaLineHeightPx(ta, 22);
        const lineTop = (line - 1) * lineHeight;
        const desiredTop = lineTop - (ta.clientHeight / 2 - lineHeight / 2);

        const maxScrollTop = Math.max(0, ta.scrollHeight - ta.clientHeight);
        const targetTop = Math.min(Math.max(0, desiredTop), maxScrollTop);
        ta.scrollTop = targetTop;

        // 3) 강조 점멸: 잠시 선택 상태로 두었다가 커서만 남김
        // setTimeout(() => {
        //   ta.setSelectionRange(end, end);
        // }, 10000);
      });

      // 상태는 변경하지 않음 → 리렌더로 인해 selection/scroll이 깨지는 것 방지
      return prev;
    });
  };

  return (
    <Paper sx={{width:"100%", overflow: "auto"}}>
      {backdrop && ( <SearchBackDrop message={"처리중..."}/> )}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>장문(LDKP) - 데이터 검수</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">
        <Box display="flex">

          {/* 원천데이터 */}
          <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
            <Box sx={{width:"800px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
              <Box sx={{display:"flex", alignItems:"center"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px"}}>document_id</Box>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px"}}>{colEvltData.document_id}</Box>
                    </Box>
                    <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                    <Box><textarea value={detailInfo.document_title} readOnly={true} spellCheck="false" style={{width:"790px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                    <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                    <Box><textarea ref={textareaRef} readOnly={true} value={detailInfo.modified_context} wrap="off" spellCheck="false" style={{width:"790px",minHeight:"720px", lineHeight:"22px", fontSize:"15px", fontWeight:600,padding:"2px", whiteSpace: "pre", fontFamily: "Noto Sans KR"}}  /></Box>

                  </Box>
                </Box>
              </Box>
            </Box>
          </Paper>
          {/* 원천데이터 */}

          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#e4ffdc"}}>
              <Box sx={{margin:"4px"}}>
                <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                  <Box>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>문장 삽입</Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Question</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea spellCheck="false" value={colEvltData.question || ""} onChange={(e) => {setColEvltData({ ...colEvltData, question: e.target.value });}} style={{border:"4px solid #000", width:"740px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea spellCheck="false" value={colEvltData.answer || ""} onChange={(e) => {setColEvltData({ ...colEvltData, answer: e.target.value });}} style={{border:"4px solid #000", width:"740px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                  </Box>
                </Box>
              </Box>

              {/* 문장삽입 정보 */}
              <Box>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>InsertSentence Info</Box>
                <Box sx={{margin:"8px", height:"240px", overflow:"auto", border:"4px solid #000"}}>
                {detailInfo.json_preview && detailInfo.json_preview.items.map((item:any, index:any) => 
                  <Box key={"Box"+index} sx={{fontWeight:700, margin:"4px", border:"4px solid #4649ff"}}>
                    {item && item.context.map((context:any, index:any) => 
                      <Box key={"context"+index} sx={{display:"flex",}}>
                        <Box sx={{marginLeft:"4px", lineHeight: "28px" }}>
                          <Button size="small" sx={{height:"20px", backgroundColor:"#3899c5"}} variant="contained" onClick={() => goToLineChange(Number(context.line))}>{context.line} line</Button>
                        </Box>
                        <textarea key={index} readOnly={true} spellCheck="false" value={context.text || ""} style={{backgroundColor:(context.is_inserted ? "#ffd06c" : "#fff"),width:"680px",minHeight:"24px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                      </Box>
                    )}
                  </Box>
                )}
                </Box>
              </Box>

              <Box sx={{width:"100%", marginTop: "16px"}}>
                <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                  <Box sx={{margin:"4px 4px 4px 4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px", width:"420px"}}>
                      <Box sx={{fontSize:"24px", fontWeight:700, textAlign:"center", margin:"2px"}}>추론경로(CoT)</Box>
                      </Box>
                      <Box><Button sx={{backgroundColor:"#9169ff"}} variant="contained" onClick={handleAdd}>항목 추가</Button></Box>
                    </Box>
                  </Box>
  
                  <Box sx={{width:"750px",margin:"4px", height:"200px", overflow:"auto"}}>
                    <Box sx={{margin:"4px 0px 4px 2px", color:"#4664b4", fontWeight:700}}>Reason Path ({reason_path && reason_path.length})</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                        {reason_path && reason_path.map((item:any, index:any) => 
                          <Box key={"Box"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                            <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                            <textarea key={index} spellCheck="false" value={item || ""}  onChange={(e) => reason_path_change(index, e.target.value)} style={{width:"640px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                            <DangerousRoundedIcon sx={{marginLeft:"8px"}} onClick={() => handleRemove(index)}>✕</DangerousRoundedIcon>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  
                  <Box display="flex">
                    <Box sx={{display:"flex", marginTop:"16px"}}>
                      <Box sx={{display:"flex",marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                        <Box><textarea value={(colEvltData.des === "None" ? "" : colEvltData.des) || ""} onChange={(e) => {setColEvltData({ ...colEvltData, des: e.target.value });}} style={{width:"360px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                    
                    <Box sx={{width:"100%", marginTop: "8px"}}>
                      <Box display="flex" justifyContent="center">
                        <Button variant="contained" color="primary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                          onClick={() => {
                            updateInsertSentenceData();
                          }}
                        >
                          확인
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                  
                </Paper>
              </Box>
              
            </Paper>
          </Box>
          {/* 삽입문장 리스트 */}
        </Box>
      <Box>
        {/* 작업목록 */}
        <Box display="flex" justifyContent="center" >
          <Box sx={{padding:"4px 8px 8px 8px", width:"368px"}}>
            <Box display="flex">
              <Box><img style={{width:"24px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} /></Box>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>작업목록</Box>
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>검수</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>유형</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                {(evknWorkList != undefined && evknWorkList.length > 0) ? evknWorkList.map((row:any, index:number) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(colEvltData != undefined && row.idx === colEvltData.idx ? "#dbdbef": "#fff")}}
                    onClick={()=> {getSentencesData(row); getInsertSentenceDetail(row.document_id, row.sentence_id); setPageType("update"); }}
                  >
                    <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.job_yn === "Y" ? "2px solid #27cc2f" : (row.job_yn === "P" ? "2px solid #7427cc" : "#000")), color:"#000" }}>
                        {(row.job_yn === "Y" ? "완료" : (row.job_yn === "P" ? "X" : "미작업"))}
                      </Box>
                    </TableCell>
                  </TableRow>
                  )):<TableRow><TableCell colSpan={3} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{marginTop:"12px"}}>
              {pagination !== undefined ? (
                  <>
                  <CustomPagination pagination={pagination} goPage={goPage} />
                  <Box display="flex">
                    <TextField size="small" id="worker" value={c_page} onChange={(e)=>setC_page(e.target.value)} 
                      sx={{width:"60px",height: "23px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} 
                      InputProps={{
                        style: {width: "60px", height:"23px", fontSize:"12px"},
                        inputProps: { 
                          spellCheck: "false" // spellcheck를 false로 설정
                        },
                      }}
                    />
                    <Button variant="contained" sx={{marginLeft:"8px",minWidth: "58px", height:"30px", fontSize:"12px"}} onClick={()=>setPage(Number(c_page))}>
                      이동
                    </Button>
                  </Box>
                  </>
              ) : ""}
            </Box>
          </Box>
        </Box>
      </Box>
      </Box>
    </Paper>
  );
  
  
};

export default EvltInsertSentencePage;
